"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yearEndCloseResponse = exports.periodCloseChecksResponse = exports.yearEndStatus = exports.periodCheckItem = exports.periodCheckCode = exports.closePeriodRequest = exports.reopenPeriodRequest = exports.fiscalPeriodDto = exports.periodStatus = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const ledger_1 = require("./ledger");
const settings_1 = require("./settings");
exports.periodStatus = zod_1.z.enum(['OPEN', 'CLOSED']);
/** فترة مالية بحالتها. `closedAt`/`closedBy` لآخر إقفال سارٍ، ويُفرَّغان عند إعادة الفتح. */
exports.fiscalPeriodDto = zod_1.z.object({
    id: common_1.uuid,
    companyId: common_1.uuid,
    startDate: common_1.isoDate,
    endDate: common_1.isoDate,
    status: exports.periodStatus,
    closedAt: zod_1.z.string().nullable(),
    closedBy: common_1.uuid.nullable(),
});
/**
 * إعادة فتح فترة مقفلة تمس أرقامًا رآها أحد بالفعل (إقرار، قوائم، مراجع)،
 * فالسبب إلزامى ويُحفظ فى سجل التدقيق. يُقصّ قبل فحص الطول حتى لا تمرّ مسافات.
 */
exports.reopenPeriodRequest = zod_1.z
    .object({
    reason: zod_1.z.string().trim().min(10, 'reason must be at least 10 characters').max(500),
})
    .strict();
/**
 * طلب الإقفال: بلا جسم، أو `acknowledgeWarnings: true` لإقرار تحذيرات فحوص ما قبل
 * الإقفال (الفحوص بوضع `warn` فى الإعدادات). فحوص `block` لا يتجاوزها الإقرار.
 */
exports.closePeriodRequest = zod_1.z
    .object({ acknowledgeWarnings: zod_1.z.boolean().default(false) })
    .strict()
    .optional();
exports.periodCheckCode = zod_1.z.enum(['BANK_NOT_RECONCILED', 'OPENING_DIFFERENCE_NOT_ZERO']);
exports.periodCheckItem = zod_1.z.object({
    code: exports.periodCheckCode,
    mode: settings_1.periodCheckMode,
    message: zod_1.z.string(),
    details: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
});
/** حالة إقفال السنة للفترة الأخيرة فى سنتها — لتعرض الشاشة الإجراء أو تخفيه. */
exports.yearEndStatus = zod_1.z.object({
    mode: zod_1.z.enum(['auto_entry', 'manual', 'reports_only']),
    fiscalYear: zod_1.z.number().int(),
    /** هل هذه آخر فترة فى سنتها المالية — قيد الإقفال يُرحَّل فى آخر يوم منها. */
    isLastPeriodOfYear: zod_1.z.boolean(),
    /** قيد الإقفال المنشور لهذه السنة، أو `null`. */
    journalId: common_1.uuid.nullable(),
    journalNumber: zod_1.z.string().nullable(),
});
/** قائمة ما قبل إقفال فترة: ما فُحص ونتيجته، وما يمنع وما يحتاج إقرارًا. */
exports.periodCloseChecksResponse = zod_1.z.object({
    periodId: common_1.uuid,
    periodEndDate: common_1.isoDate,
    checks: zod_1.z.array(zod_1.z.object({ code: exports.periodCheckCode, mode: settings_1.periodCheckMode, passed: zod_1.z.boolean() })),
    blocking: zod_1.z.array(exports.periodCheckItem),
    warnings: zod_1.z.array(exports.periodCheckItem),
    /** لا شىء يمنع — والتحذيرات، إن وُجدت، تحتاج `acknowledgeWarnings`. */
    canClose: zod_1.z.boolean(),
    yearEnd: exports.yearEndStatus,
});
/** نتيجة قيد إقفال السنة: القيد وصافى النتيجة المرحّل إلى الأرباح المرحلة. */
exports.yearEndCloseResponse = zod_1.z.object({
    fiscalYear: zod_1.z.number().int(),
    netIncome: common_1.moneyString,
    journal: ledger_1.journalDto,
    replayed: zod_1.z.boolean(),
});
//# sourceMappingURL=period.js.map